import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "30",
  height: "30",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "1.6",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M6.5 4.5h17a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H15L10 25v-4.5H6.5a3 3 0 0 1-3-3v-10a3 3 0 0 1 3-3" }, null, -1 /* CACHED */),
    _createElementVNode("path", { d: "M13 8h4m-3.2 0v3.5l-2.9 4.8a.8.8 0 0 0 .7 1.2h6.8a.8.8 0 0 0 .7-1.2l-2.9-4.8V8" }, null, -1 /* CACHED */)
  ]))]))
}
export default { render: render }